import { useSearchParams as useReactRouterSearchParams } from 'react-router-dom';

// ----------------------------------------------------------------------

/**
 * Normalizes React Router's `[params, setParams]` tuple down to a bare
 * `URLSearchParams`, matching the previous Next.js `useSearchParams()` shape
 * so existing `.get(...)` call sites stay unchanged.
 */
export function useSearchParams(): URLSearchParams {
  const [searchParams] = useReactRouterSearchParams();
  return searchParams;
}
